import {Component, OnInit} from '@angular/core';
import {AddOrderTransmissionService} from 'src/app/raintree/transmission/order-transmission/order-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {OrderList} from '../interface/order-list';
import {OrderCancellationDialogComponent} from "../order-cancellation-dialog/order-cancellation-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {OrderListBpm} from "../interface/order-list-bpm";
import {ActivatedRoute} from "@angular/router";
import {BloomsightService} from "../../bloomsight.service";
import {GlobalService} from "../../services/global.service";

@Component({
	selector: 'fb-profile-order-listing',
	templateUrl: './profile-order-listing.component.html',
	styleUrls: ['./profile-order-listing.component.scss']
})
export class ProfileOrderListingComponent implements OnInit {

	public orderListBpm: OrderListBpm[] = [];
	public filteredOrderList: OrderListBpm[] = [];
	public isPreviousOrderHistoryOpen: boolean = false;
	public today: number = new Date().getTime();
	public msIn24Hours = 24 * 60 * 60 * 1000;
	public selectedTab: string = 'ALL';
	public activeOrders: OrderListBpm[] = [];
	public completedOrders: OrderListBpm[] = [];
	public cancelledOrders: OrderListBpm[] = [];

	constructor(
		private _route: ActivatedRoute,
		public _toast: ToastMessageService,
		private _orderTransmission: AddOrderTransmissionService,
		private _dialog: MatDialog,
		private _bloomsight: BloomsightService,
		public globalService: GlobalService
	) {
	}

	public ngOnInit(): void {
		this.getOrderListV2();

		this._route.queryParams.subscribe(params => {
			this.selectedTab = params['tab'] === 'active'? 'PROCESSING':'ALL';
		})
	}

	public getOrderListV2(): void {
		this._orderTransmission.getOrderListBpm(
			'?pageNumber=0&pageSize=25',
			() => {
			},
			() => {
			},
			(response: OrderListBpm[]) => {
				this.orderListBpm = response;
				this.orderListBpm = this.orderListBpm
					.filter(
						(order: OrderListBpm) => !['FAILED', 'INITIATED'].includes(order.status)
					).sort((a: OrderListBpm, b: OrderListBpm) => b.createdAt - a.createdAt);


				this.activeOrders = this.orderListBpm.filter(order => ['PROCESSING', 'IN_TRANSIT'].includes(order.status));
				this.cancelledOrders = this.orderListBpm.filter(order => order.status === 'CANCELLED');
				this.completedOrders = this.orderListBpm.filter(order => order.status === 'DISPATCHED');

				this.filterOrder(this.selectedTab);
			},
			() => {
			},
			() => {
			}
		)
	}

	public cancelOrder(orderId: number): void {
		this._dialog.open(OrderCancellationDialogComponent, {
			data: { orderId: orderId },
			maxWidth: '80vw',
			maxHeight: '90vh'
		});
	}

	public openPreviousOrderHistory(): void {
		this.isPreviousOrderHistoryOpen = !this.isPreviousOrderHistoryOpen;
	}

	public filterOrder(key: string): void {
		this.selectedTab = key;
		if(key === 'ALL') {
			this.filteredOrderList = [
				...this.activeOrders,
				...this.completedOrders,
				...this.cancelledOrders
			];
		}
		else if (key === 'PROCESSING') {
			this.filteredOrderList = this.orderListBpm.filter(order => ['PROCESSING', 'IN_TRANSIT', 'INITIATED'].includes(order.status));
		}
		else {
			this.filteredOrderList = this.orderListBpm.filter(order => order.status === key);
		}
		this._bloomsight.trackDataEvent(
			'67c98798fa5f5a9c91607750',
			[
				{option: this.selectedTab === 'PROCESSING' ? 'ACTIVE' : this.selectedTab},
				{email: this.globalService.customerProfileData.tenant.email},
				{userId: this.globalService.customerProfileData.tenant.uid},
				{all: this.selectedTab + '-' + this.globalService.customerProfileData.tenant.email + '-' + this.globalService.customerProfileData.tenant.uid },
			],
			'Order Listing Option'
		);
	}
}
